import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoadingOptions, LoadingRef, LoadingService } from '../loading.service';
import { LoadingDialogComponent } from './loading-dialog.component';

class DialogLoadingRef implements LoadingRef {
  constructor(private dialogRef: MatDialogRef<LoadingDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }

  updateMessage(message: string): void {
    this.dialogRef.componentInstance.updateMessage(message);
  }

  isActive(): boolean {
    return this.dialogRef.getState() === 0;
  }
}

@Injectable()
export class DialogLoadingService extends LoadingService {
  #dialog = inject(MatDialog);
  #activeLoadings = new Set<MatDialogRef<LoadingDialogComponent>>();

  show(options?: LoadingOptions): LoadingRef {
    const dialogRef = this.#dialog.open(LoadingDialogComponent, {
      data: {
        message: options?.message || 'Cargando...',
        cancelable: options?.cancelable || false,
        onCancel: options?.onCancel,
      },
      disableClose: !options?.cancelable,
      hasBackdrop: true,
    });

    this.#activeLoadings.add(dialogRef);

    if (options?.timeout) {
      setTimeout(() => {
        if (this.#activeLoadings.has(dialogRef)) {
          dialogRef.close();
        }
      }, options.timeout);
    }

    dialogRef.afterClosed().subscribe(() => {
      this.#activeLoadings.delete(dialogRef);
    });

    return new DialogLoadingRef(dialogRef);
  }

  hideAll(): void {
    this.#activeLoadings.forEach((dialogRef) => {
      dialogRef.close();
    });
    this.#activeLoadings.clear();
  }

  hasActiveLoading(): boolean {
    return this.#activeLoadings.size > 0;
  }
}
